<template>
    <div class="lo router">
        <loPage>
            <loSection>
                <loArticle>
                    <mdCartCaption
                        :caption="$t('page.search.caption.searchresult')"
                        :needBottomLine="false"
                    ></mdCartCaption>
                    <div class="md search major">
                        <div class="cp input text">
                            <input type="text" :placeholder="$t('page.search.func.search')" v-model="search" @input="setShow">
                        </div>
                        <div class="func">
                            <a href="#" @click.prevent="remove" v-if="search"></a>
                        </div>
                    </div>
                    <gProductList
                        :list="list"
                        showMode="list"
                        :haveSort="false"
                        :havePageination="false"

                        @sendEvent="receiveEvent"
                    >
                        <div class="cp input inline-text" slot="search">{{ $t('ssss.ddd',{
                            length: length
                        }) }}</div>
                    </gProductList>
                </loArticle>
            </loSection>
        </loPage>
    </div>
</template>

<script>
    import loPage from '@/components/loPage'
    import mdCartCaption from '@/components/mdCartCaption'
    import loSection from '@/components/loSection'
    import loArticle from '@/components/loArticle'
    import gProductList from '@/components/gProductList'
    import cpBtn from '@/components/cpBtn'

    import { mapState, mapMutations } from 'vuex'

    export default {
        components: {
            loPage,
            mdCartCaption,
            loSection,
            loArticle,
            gProductList,
            cpBtn,
        },
        data: function(){

            return {
                list: [],
                search: '', //搜尋字串
            }
        },
        computed: {
            ...mapState([
                'user',
                'langID',
                'token',
                'productClass',
                'productList',
            ]),
            length: function(){
                let $list = this.list,
                    $filter = $list.filter(item => item.show);

                return $filter.length;
            }
        },
        watch: {
            productList: {
                handler: function(){
                    this.initProductData();
                }
            },
        },
        methods: {
            ...mapMutations([
                'catchError',
            ]),
            setShow: function(){
                let $list = this.list,
                    _search = this.search;

                _search = _search.toLowerCase();
                
                $list.forEach(item => {
                    let _str = item.product_b +'__'+ item.product_m +'__'+ item.product_s,
                        _show = false;

                    _str = _str.toLowerCase();

                    if( _search && _str.includes(_search) ) {
                        _show = true;
                    }

                    item.show = _show;
                });
            },
            clickProduct: function(opt){
                let $class = opt.class || [],
                    _class = $class[0] || '';

                this.$router.push('/system/productList?class='+ _class +'&product=all&item='+ opt.sn);
            },
            favorite: function(opt){
                this.$emit('sendEvent', 'favorite', opt);
            },
            contact: function(sn){
                this.$emit('sendEvent', 'contact', sn);
            },
            remove: function() {
                this.$set(this, 'search', '');
                this.setShow();
            },
            initProductData: function(res){
                let $data = this.productList || [],
                    $result = []

                $data.forEach(item => {

                    if(item.is_on_market){
                        
                        let $node = {
                                node: item,
                                class: item.class,
                                product_b: item.product_b,
                                product_m: item.product_m,
                                product_s: item.product_s,
                                sn: item.product_sn,
                                label: item.label || '',
                                caption: item.product_s,
                                essay: item.product_b +'-'+ item.product_m,
                                image: item.imageurl,
                                favorite: item.is_favorite,
                                show: true,
                            }

                        $result.push($node);
                    }
                });

                this.$set(this, 'list', $result);
            },
            init: async function(){
                this.initProductData();
                this.setShow();
            }
        },
        created: function(){
            this.init();
        }
    }
</script>

<style scoped lang="scss">

    .lo.router {
        max-width: 992px;
        margin: 0 auto;
    }

    .md.search.major {
        $size: 48px;
        position: relative;
        padding: 0;
        margin-top: 0 !important;

        .cp.input {
            display: block;
            width: auto;

            &:before {
                @extend %font-pseudo;
                content: '\e8b6';
                position: absolute;
                left: 0;
                top: 0;
                width: $size;
                height: $size;
                line-height: $size;
                font-size: $font-size-xl;
                text-align: center;
                color: $major-color;
            }
            
            input {
                padding-left: $size;
                width: 100%;
                height: $size;
                line-height: $size;
            }
        }

        .func {

            a {
                position: absolute;
                width: $size;
                height: $size;
                right: 0;
                top: 0;
                transition: $transition;

                &:hover {
                    opacity: $opacity-m;
                }

                &:before {
                    @extend %font-pseudo;
                    content: '\e5cd';
                    width: $size;
                    height: $size;
                    line-height: $size;
                    font-size: $font-size-l;
                    text-align: center;
                    color: $deep;
                }
            }
        }
    }

    .inline-text {
        flex: 1;
    }
</style>
